/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Earningspaidon2Inputs */

const en_earningspaidon2 = /** @type {(inputs: Earningspaidon2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paid out on ${i?.date}`)
};

const de_earningspaidon2 = /** @type {(inputs: Earningspaidon2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausgezahlt am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Paid out on {date}" |
*
* @param {Earningspaidon2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningspaidon2 = /** @type {((inputs: Earningspaidon2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningspaidon2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningspaidon2(inputs)
	return de_earningspaidon2(inputs)
});
export { earningspaidon2 as "earningsPaidOn" }